/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { FormFieldProps } from '../../FormField.props';
import { SelectFieldOption } from './SelectField.defs';

/**
 * The props for `<Select />`.
 */
export interface SelectFieldProps extends FormFieldProps {
  /**
   * The function to return the chosen field option.
   */
  callback?(option: SelectFieldOption): void;

  /**
   * The default option to select.
   */
  defaultOption?: SelectFieldOption;

  /**
   * The error message to display.
   */
  errorMessage?: string | null;

  /**
   * All options for the select field.
   */
  options: Array<SelectFieldOption>;

  /**
   * Placeholder text for empty selection.
   */
  placeholder?: string;

  /**
   * Determines if the dropdown options should be positioned to prevent parent from covering them.
   * Default: `false`.
   * TODO: PLATFORM-612.
   */
  requiresCustomPosition?: boolean;

  /**
   * Prefix for displayed value in the select field.
   */
  valuePrefix?: JSX.Element | string;
}

/**
 * The default prop values for `<Select />`.
 */
export const selectPropsDefaults = {
  placeholder: ``,
};
